import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Stkwl { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsNotEmpty({message: '單號 (WL001) 不可空白'}) 
    @MaxLength(20,{message: '單號 (WL001) 資料太長'})
    WL001: string = '';            // 單號 20 ** 建檔時間 20220601-150245755

    @IsNotEmpty({message: '序號 (WL002) 不可空白'}) 
    @MaxLength(4,{message: '序號 (WL002) 資料太長'})
    WL002: string = '';            // 序號 4 

    @IsNumber() 
    WL003: number = 0;            // 排序碼 4 

    @MaxLength(1000,{message: 'text內文 (WL004) 資料太長'})
    WL004: string = '';            // text內文 1000 

    @MaxLength(8,{message: '日期 (WL005) 資料太長'})
    WL005: string = '';            // 日期 8 


    WL006: Date | undefined;            // Date 0 

    @MaxLength(100,{message: '主旨 (WL007) 資料太長'})
    WL007: string = '';            // 主旨 100 

    @MaxLength(1,{message: '星號 (WL008) 資料太長'})
    WL008: string = 'N';            // 星號 1 [DEF:"N"]

    @MaxLength(100,{message: '來源單號 (WL009) 資料太長'})
    WL009: string = '';            // 來源單號 100 

    @MaxLength(10,{message: '股票代號 (WL010) 資料太長'})
    WL010: string = '';            // 股票代號 10 WL001=STKMA.MA001 MTRWD.WD015='03'

    @MaxLength(1,{message: 'tag (WL011) 資料太長'})
    WL011: string = 'N';            // tag 1 [DEF:"N"]

    @MaxLength(1,{message: '格式 (WL012) 資料太長'})
    WL012: string = 'T';            // 格式 1 [DEF:"T"]  T:text H:html M:markdown

    @MaxLength(2000,{message: 'html內文 (WL013) 資料太長'})
    WL013: string = '';            // html內文 2000 


}
